/**
 * Evaluate if the given string is a percentage expression
 * @param {String} value string to evaluate
 */
import i18n from "@/i18n";

const isPercentage = value => {
	if (typeof value === "string" && value.includes("%")) {
		return true;
	}

	return false;
};

/**
 * @param {Number} total Amount to convert to percentage
 * @param {String} percentage of the amount to be extracted
 */
const convertPercentageToAmount = (total, percentage) => {
	const value = convertStringToNumber(percentage, true);

	return convertNumberToString((total * value) / 100, 5);
};

const convertAmountToPercentage = value => {
	if (isPercentage(value)) {
		return value;
	}

	const number = convertNumberToString(value);

	return `${number}%`;
};

const convertNumberToString = (value, maximumFractionDigits = 7) => {
	maximumFractionDigits = typeof maximumFractionDigits === "number" ? maximumFractionDigits : 7;

	// .format require a number so we convert the string to number first
	const number = convertStringToNumber(value);
	const currentLocale = i18n.locale === "en" ? "en-US" : "fr-FR";
	const amount = new Intl.NumberFormat(currentLocale, {
		minimumFractionDigits: maximumFractionDigits < 2 ? 0 : 2,
		maximumFractionDigits
	}).format(number);

	return amount;
};

function phpRound(number) {
	if (number < 0) {
		return 0 - Math.round(0 - number);
	}

	return Math.round(number);
}

// 1 922.00 -> 1922
const convertStringToNumber = (value, maximumFractionDigits, toLocale = i18n.locale) => {
	let _value = String(value).replace(/\s/g, "");
	if (toLocale === "en") {
		// well-formated number with decimals 1,200.34
		if (/[0-9,]+\.[0-9]{1,5}/.test(_value)) {
			_value = _value.replace(/,/g, "");
		} else if (_value.includes(",")) {
			const commas_count = (_value.match(/,/g) || []).length;
			// ambiguous case : "12,34" → probably "12.34" (2 digits decimals)
			if (commas_count === 1 && ( _value.length - (_value.lastIndexOf(",") +1) === 2)) {
				_value = _value.replace(",", ".");
			} else {
				// Case "1,200" ou "1,200,000"
				_value = _value.replace(/,/g, "");
			}
		}

	} else {
		// FR: 1 980,90 => 1980.90
		_value = _value.replace(",", ".");
	}


	let float = parseFloat(_value);

	if (maximumFractionDigits) {
		const decimals = Math.pow(10, maximumFractionDigits);
		float = phpRound(float * decimals) / decimals;
	}

	if (isNaN(float)) {
		return 0.0;
	}

	return float;
};

const truncate = (str, n = 25) => (str && str.length > n ? str.substr(0, n - 1) + "..." : str);

export {
	convertPercentageToAmount,
	convertAmountToPercentage,
	convertNumberToString,
	convertStringToNumber,
	truncate,
	phpRound
};
